export const ACTIVE_OUTREACH = { id: 1, url: 'https://app.opinionx.co/safe-power-user-survey/' }

export const OUTREACH_LS_KEY = 'outreachPopup'
export const OUTREACH_SS_KEY = 'outreachPopup_session'

export const HOUR_IN_MS = 60 * 60 * 1000
export const MAX_ASK_AGAIN_DELAY = HOUR_IN_MS * 24
